module.exports = __webpack_public_path__ + "images/drawings/moon/full-moon.414b89fe486f957c0dc0910fea15ea25.png";